import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    officials_groups: {
        ".mantine-Stack-root": {
            "> div": {
                display: "block",
            },
        },
    },
}))
